<template>
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_2011_537" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="20">
      <rect x="0.772217" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2011_537)">
      <path
        d="M5.27222 14C4.85972 14 4.50659 13.8531 4.21284 13.5594C3.91909 13.2656 3.77222 12.9125 3.77222 12.5V7.5C3.77222 7.0875 3.91909 6.73438 4.21284 6.44063C4.50659 6.14688 4.85972 6 5.27222 6H16.2722C16.6847 6 17.0378 6.14688 17.3316 6.44063C17.6253 6.73438 17.7722 7.0875 17.7722 7.5V12.5C17.7722 12.9125 17.6253 13.2656 17.3316 13.5594C17.0378 13.8531 16.6847 14 16.2722 14H5.27222ZM5.27222 12.5H16.2722V7.5H5.27222V12.5ZM4.50138 4.5C4.30694 4.5 4.1368 4.42813 3.99097 4.28438C3.84513 4.14063 3.77222 3.9625 3.77222 3.75C3.77222 3.55556 3.84861 3.38194 4.00138 3.22917C4.15416 3.07639 4.32777 3 4.52222 3H17.0431C17.2549 3 17.4294 3.07639 17.5666 3.22917C17.7037 3.38194 17.7722 3.55903 17.7722 3.76042C17.7722 3.96181 17.7003 4.13542 17.5566 4.28125C17.4128 4.42708 17.2347 4.5 17.0222 4.5H4.50138ZM4.50138 17C4.30694 17 4.1368 16.9281 3.99097 16.7844C3.84513 16.6406 3.77222 16.4625 3.77222 16.25C3.77222 16.0556 3.84861 15.8819 4.00138 15.7292C4.15416 15.5764 4.32777 15.5 4.52222 15.5H17.0431C17.2549 15.5 17.4294 15.5764 17.5666 15.7292C17.7037 15.8819 17.7722 16.059 17.7722 16.2604C17.7722 16.4618 17.7003 16.6354 17.5566 16.7812C17.4128 16.9271 17.2347 17 17.0222 17H4.50138Z"
        :fill="fillColor" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fillColor: {
      get() {
        if (this.isActive) return "#49545C";

        return "rgba(73, 84, 92, 0.30)";
      },
      set(color) {
        return color;
      }
    }
  }
}
</script>
